import { AvpContextClaims } from '@org-avp/context-claims';
import type { Claims } from '@org-avp/context-claims';
import { brandSchema, marketSchema } from 'data/schema';
import type { IBrand, IMarket } from 'data/schema';

/** Resolves the primary landing tenant from account claims, defaulting to A/DEU. */
export function getLandingBrandMarket(claims: Claims | null): { brand: IBrand; market: IMarket } {
  const brands = claims ? AvpContextClaims.getBrands(claims) : [];
  const rawBrand =
    brands[0] || (claims ? JSON.parse((claims['custom:brands'] as string) ?? '[]')[0] : undefined) || 'A';
  const markets = claims ? AvpContextClaims.getMarkets(claims) : [];
  const rawMarket =
    markets[0] || (claims ? JSON.parse((claims['custom:markets'] as string) ?? '[]')[0] : undefined) || 'DEU';

  const brand = brandSchema.safeParse(rawBrand);
  const market = marketSchema.safeParse(rawMarket);

  return {
    brand: brand.success ? brand.data : 'A',
    market: market.success ? market.data : 'DEU',
  };
}
